<div class="indicator">
  @switch (itemType) {
    @case ('TD') {
      <span [class.lowercase]="!original" title="This is the document that is already showing">This document</span>
    }
    @case ('TI') {
      <span [class.lowercase]="!original" title="This is the interchange that is already showing">This interchange</span>
    }
    @case ('OD') {
      <div>
        <span [class.lowercase]="!original">Document </span>
        <button class="btn btn-link" title="Click to open related document" (click)="openRelation()">{{relationDocumentId}}</button>
      </div>
    }
    @case ('OI') {
      <div>
        <span [class.lowercase]="!original">Interchange </span>
        <button class="btn btn-link" title="Click to open related interchange or document" (click)="openRelation()">{{relationInterchangeId}}</button>
      </div>
    }
    @default {
      <div>?? {{itemType}} ??</div>
    }
  }
</div>
